import { FullscreenButtonMargin, PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';

const FORM_PAGES = ['start', 'middle', 'middle2', 'middle3', 'middle4', 'end'] as const;
export type FullscreenFormPage = typeof FORM_PAGES[number];

export function isFullscreenBackgroundPopup(form: TFormSaveDetailRequest<PopSettingsVO>): boolean {
  return Number(form.popWindowWheel) === 0
    && form.settings?.rules?.popupLayoutMode === 'fullscreen'
    && form.settings?.typesetting?.imgPosition === 'background'
    && !form.settings?.scratchCard;
}

export function hasContactInFullscreenSteps(settings: PopSettingsVO): boolean {
  const enabledPages = settings.pageSettings?.length
    ? FORM_PAGES.filter(page => settings.pageSettings?.some(item => item.value === page))
    : FORM_PAGES;
  return enabledPages.some(page => {
    const fields = settings[page] || [];
    return fields.some(field => field.type === 'Email' || field.type === 'Mobile Number');
  });
}

export function getFullscreenButtonMargin(
  rules: PopSettingsVO['rules'], page: FullscreenFormPage
): FullscreenButtonMargin {
  const margin = rules.fullscreenMainButtonMargins?.[page];
  const safe = (value?: number) => Math.min(100, Math.max(0, Number(value) || 0));
  return {
    top: safe(margin?.top),
    right: safe(margin?.right),
    bottom: safe(margin?.bottom),
    left: safe(margin?.left)
  };
}
